import { EditBlockPosition } from '@components/EditBuildingBlocks/all'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    component: {
      type: Object,
      required: true,
    },
    isGlobalContentItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    'edit-block-position': EditBlockPosition,
  },
  computed: {
    ...mapState('editor', [
      'availableFontsList',
      'headlineFontSizesList',
      'textFontSizesList',
      'buttonFontSizesList',
      'textAlignList',
      'flexBoxAlignList',
      'showContentMenu',
      'showSettingsMenu',
    ]),
  },
  methods: {
    ...mapActions('campaign/contentItem',
      ['updateContentItem', 'updateGlobalContentItem']),
  },
}
